import { render, staticRenderFns } from "./HomeTabbar.vue?vue&type=template&id=50a75152&scoped=true"
import script from "./HomeTabbar.vue?vue&type=script&lang=js"
export * from "./HomeTabbar.vue?vue&type=script&lang=js"
import style0 from "./HomeTabbar.vue?vue&type=style&index=0&id=50a75152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a75152",
  null
  
)

export default component.exports